module.exports = __webpack_public_path__ + "static/media/logo.06e85fdc.svg";